module.exports = __webpack_public_path__ + "2c4b1f14d1904e5475d2b67e1fa51d08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/bill_active.png
// module id = 741
// module chunks = 0